import {Component} from '@angular/core';

@Component({
    selector: 'qa-error-page',
    templateUrl: './error-page.component.html',
    styleUrls: ['./error-page.component.scss'],
    standalone: false
})
export class ErrorPageComponent {

  constructor() { }


}
